<template>
  <validation-observer
    id="stepIntroForm"
    ref="form"
    tag="form"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <vvs-input
      name="Firma Yetkili Adı Soyadı"
      label="1. Firma Yetkili Adı Soyadı"
      validate="required|withoutEmoji|alpha_spaces|min:3|max:255"
      v-model="form.contacts[0].name"
    ></vvs-input>

    <vvs-textarea
      name="Firmadaki Pozisyonu"
      label="2. Firmadaki Pozisyonu"
      placeholder="Muhasebe Müdürü, Operasyon Şefi, Üretim Sorumlusu, Genel Müdür, Şirket Ortağı vb."
      validate="required|withoutEmoji|min:3|max:255"
      two-line
      v-model="form.contacts[0].title.tr"
    ></vvs-textarea>

    <vvs-input
      type="email"
      name="E-Posta"
      label="3. E-posta"
      placeholder="İletişim kurulacak e-posta adresini girin."
      validate="required|email"
      v-model="form.contacts[0].email"
    ></vvs-input>

    <vvs-input
      type="tel"
      name="Cep Telefonu"
      label="4. Cep Telefonu"
      placeholder="0(___) ___ __ __"
      mask="0(###) ### ## ##"
      validate="required|min:16"
      validate-mode="lazy"
      v-model="form.contacts[0].phone"
    ></vvs-input>

    <vvs-recaptcha
      v-if="showRecaptcha"
      name="Google Recaptcha"
      validate="required"
      v-model="googleVerifyKey"
    ></vvs-recaptcha>

    <vvs-submit-button
      title="İLERİ &gt;"
      description="* doldurulması zorunlu alan"
    ></vvs-submit-button>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'contactInformation',
  mixins: [stepsMixin],
};
</script>
